export const es_login= {
    username: 'Direcciòn de correo electrònico',
    password: 'Contraseña',
    letto: 'He leido y acepto las',
    condizioni: 'condiciones de venta',
    dimenticato: '¿Has olvidado tu contraseña?',
    login: 'Acceder',
    utilizza: 'Usa tus credenciales de',
};